import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { TableColumns } from '@/components/table/types';
import guid from '@/shared/utils/guid';
import { formatPercentage } from '@/shared/utils/percentage';
import { IManagerInvestment } from '../../types';
import MobileSumFooter from '../mobileSumFooter';

type MobileTableProps = {
  columns: TableColumns[];
  tableData: IManagerInvestment[];
  loading: boolean | undefined;
  openInvestmentDetails: (id: string) => void;
};

const MobileTable = ({ columns, tableData, loading, openInvestmentDetails }: MobileTableProps) => {
  const TableRow = ({ el }: { el: IManagerInvestment }) => {
    return (
      <MobileTableRowWrap key={el.id}>
        <MobileRow>
          <MobileRowTitle>{columns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => openInvestmentDetails(el.id)}>
            {el.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[1].title}</MobileRowTitle>
          <MobileRowValue>{el.managerId && el.managerId}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[2].title}</MobileRowTitle>
          <MobileRowValue>{formatPercentage(el.maxCalledPercent)}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.countOfInvestors}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[4].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip key={guid()}>{el.committedCapital}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableData?.length ? (
        <>
          {tableData.map((el, index) => {
            return <TableRow el={el} key={guid()} />;
          })}
          <MobileSumFooter tableData={tableData} />
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;
